<template>
  <div class="relative w-full lg:h-[70vh] h-[30vh]">
    <!-- Background Image -->
    <div class="absolute inset-0 overflow-hidden">
      <img
        src="../assets/images/HERO Pages ALL 2.png"
        alt="Background"
        class="w-full h-full object-cover"
      />
      <div class="absolute inset-0 bg-black opacity-50"></div>
    </div>

    <!-- Content Wrapper -->
    <div
      class="relative max-w-screen-4xl mx-auto h-full flex flex-col lg:flex-row items-center justify-center px-6 lg:px-32"
    >
      <h2
        class="text-white text-center text-3xl font-black animate__animated animate__backInLeft"
      >
        Earn With Us
      </h2>
    </div>

    <!-- SVG Curve (Aligned to Background) -->
    <svg viewBox="0 0 1440 320" class="absolute bottom-0 left-0 w-full">
      <path
        fill="#ffffff"
        d="M0,224L80,208C160,192,320,160,480,176C640,192,800,256,960,266.7C1120,277,1280,235,1360,213.3L1440,192V320H0Z"
      ></path>
    </svg>
  </div>

  <!-- The text and form setion -->
  <div
    class="md:px-10 max-w-screen-4xl mx-auto relative z-10 mt-4 px-6 lg:-mt-20"
  >
    <!-- Title Section -->
    <div class="strategic-card lg:px-14 px-4">
      <h2 class="text-yellow text-2xl">
        Refer To Earn <br />
        A Commission!
      </h2>
    </div>

    <div class="lg:px-6 px-2 max-w-screen-4xl mx-auto -mt-10">
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-10 py-10">
        <!-- Info Section -->
        <div>
          <!-- <h2 class="Mulish peaks-style">Refer To Earn A Commission!</h2> -->
          <p class="text-gray-600">
            Join our referral program and earn a commission on sales with these
            simple steps: Register, share our flyers with your close network,
            and earn up to 5% commission when they buy.
          </p>

          <div class="mt-6 flex flex-col md:flex-row gap-2 items-stretch">
            <div class="flex-1 flex items-center gap-4 p-4 border rounded-lg">
              <div
                class="p-2 bg-yellow w-8 h-8 flex items-center justify-center rounded-full"
              >
                <i class="fa-solid fa-phone text-lg text-white"></i>
              </div>
              <div>
                <p class="font-semibold">Contact Us</p>
                <a
                  href="tel:+2348074918900"
                  class="text-blue-500 hover:underline"
                  >+234-807-491-8900</a
                >
              </div>
            </div>

            <div class="flex-1 flex items-center gap-4 p-4 border rounded-lg">
              <div
                class="p-2 bg-yellow w-8 h-8 flex items-center justify-center rounded-full"
              >
                <i class="fa-solid fa-envelope text-lg text-white"></i>
              </div>
              <div>
                <p class="font-semibold">Send Message</p>
                <a
                  href="mailto:info@mshelhomes.com"
                  class="text-blue-500 hover:underline"
                  >info@mshelhomes.com</a
                >
              </div>
            </div>
          </div>
        </div>

        <!-- Contact Form -->
        <div
          class="bg-white p-2 lg:p-6 rounded-lg shadow-lg max-w-lg mx-auto lg:-mt-36 strategic-card"
        >
          <form class="max-w-xl mx-auto space-y-6" @submit.prevent="submitForm">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
              <!-- Full Name -->
              <div class="space-y-1">
                <label class="text-sm font-medium"
                  >Full Name <span class="text-red-500">*</span></label
                >
                <input
                  type="text"
                  placeholder="Full Name"
                  v-model="name"
                  class="w-full p-3 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-yellow-400"
                />
              </div>

              <!-- Email -->
              <div class="space-y-1">
                <label class="text-sm font-medium"
                  >Email <span class="text-red-500">*</span></label
                >
                <input
                  type="email"
                  v-model="email"
                  placeholder="Email"
                  @input="validateEmail"
                  class="w-full p-3 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2"
                  :class="{
                    'ring-red-500': emailError,
                    'ring-yellow-400': !emailError && email,
                  }"
                />
                <p v-if="emailError" class="text-red-500 text-xs mt-1">
                  Please enter a valid email address.
                </p>
              </div>

              <!-- Phone Number -->
              <div class="space-y-1">
                <label class="text-sm font-medium"
                  >Whatsapp Number <span class="text-red-500">*</span></label
                >
                <input
                  type="tel"
                  v-model="phone"
                  placeholder="Enter your whatsapp number"
                  maxlength="11"
                  @input="validatePhone"
                  :class="{
                    'ring-red-500': phoneError,
                    'ring-yellow': !phoneError,
                  }"
                  class="w-full p-3 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-yellow-400"
                />
                <p v-if="phoneError" class="text-red-500 text-xs mt-1">
                  Phone number must be exactly 11 digits.
                </p>
              </div>

              <!-- Gender -->
              <div class="space-y-1">
                <label class="text-sm font-medium"
                  >Gender <span class="text-red-500">*</span></label
                >
                <select
                  v-model="gender"
                  class="w-full p-3 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-yellow-400"
                >
                  <option value="" selected disabled>Select Gender</option>
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                </select>
              </div>

              <!-- State -->
              <div class="space-y-1">
                <label class="text-sm font-medium"
                  >State <span class="text-red-500">*</span></label
                >
                <input
                  type="text"
                  v-model="state"
                  placeholder="Enter your state"
                  class="w-full p-3 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-yellow-400"
                />
              </div>

              <!-- Country -->
              <div class="space-y-1">
                <label class="text-sm font-medium">
                  Country <span class="text-red-500">*</span>
                </label>
                <select
                  v-model="country"
                  class="w-full p-3 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-yellow-400"
                >
                  <option value="">Select your country</option>
                  <option value="Afghanistan">Afghanistan</option>
                  <option value="Albania">Albania</option>
                  <option value="Algeria">Algeria</option>
                  <option value="Andorra">Andorra</option>
                  <option value="Angola">Angola</option>
                  <option value="Antigua and Barbuda">
                    Antigua and Barbuda
                  </option>
                  <option value="Argentina">Argentina</option>
                  <option value="Armenia">Armenia</option>
                  <option value="Australia">Australia</option>
                  <option value="Austria">Austria</option>
                  <option value="Azerbaijan">Azerbaijan</option>
                  <option value="Bahamas">Bahamas</option>
                  <option value="Bahrain">Bahrain</option>
                  <option value="Bangladesh">Bangladesh</option>
                  <option value="Barbados">Barbados</option>
                  <option value="Belarus">Belarus</option>
                  <option value="Belgium">Belgium</option>
                  <option value="Belize">Belize</option>
                  <option value="Benin">Benin</option>
                  <option value="Bhutan">Bhutan</option>
                  <option value="Bolivia">Bolivia</option>
                  <option value="Bosnia and Herzegovina">
                    Bosnia and Herzegovina
                  </option>
                  <option value="Botswana">Botswana</option>
                  <option value="Brazil">Brazil</option>
                  <option value="Brunei">Brunei</option>
                  <option value="Bulgaria">Bulgaria</option>
                  <option value="Burkina Faso">Burkina Faso</option>
                  <option value="Burundi">Burundi</option>
                  <option value="Cabo Verde">Cabo Verde</option>
                  <option value="Cambodia">Cambodia</option>
                  <option value="Cameroon">Cameroon</option>
                  <option value="Canada">Canada</option>
                  <option value="Central African Republic">
                    Central African Republic
                  </option>
                  <option value="Chad">Chad</option>
                  <option value="Chile">Chile</option>
                  <option value="China">China</option>
                  <option value="Colombia">Colombia</option>
                  <option value="Comoros">Comoros</option>
                  <option value="Congo (Congo-Brazzaville)">
                    Congo (Congo-Brazzaville)
                  </option>
                  <option value="Congo (Congo-Kinshasa)">
                    Congo (Congo-Kinshasa)
                  </option>
                  <option value="Costa Rica">Costa Rica</option>
                  <option value="Croatia">Croatia</option>
                  <option value="Cuba">Cuba</option>
                  <option value="Cyprus">Cyprus</option>
                  <option value="Czech Republic (Czechia)">
                    Czech Republic (Czechia)
                  </option>
                  <option value="Denmark">Denmark</option>
                  <option value="Djibouti">Djibouti</option>
                  <option value="Dominica">Dominica</option>
                  <option value="Dominican Republic">Dominican Republic</option>
                  <option value="Ecuador">Ecuador</option>
                  <option value="Egypt">Egypt</option>
                  <option value="El Salvador">El Salvador</option>
                  <option value="Equatorial Guinea">Equatorial Guinea</option>
                  <option value="Eritrea">Eritrea</option>
                  <option value="Estonia">Estonia</option>
                  <option value="Eswatini">Eswatini (fmr. "Swaziland")</option>
                  <option value="Ethiopia">Ethiopia</option>
                  <option value="Fiji">Fiji</option>
                  <option value="Finland">Finland</option>
                  <option value="France">France</option>
                  <option value="Gabon">Gabon</option>
                  <option value="Gambia">Gambia</option>
                  <option value="Georgia">Georgia</option>
                  <option value="Germany">Germany</option>
                  <option value="Ghana">Ghana</option>
                  <option value="Greece">Greece</option>
                  <option value="Grenada">Grenada</option>
                  <option value="Guatemala">Guatemala</option>
                  <option value="Guinea">Guinea</option>
                  <option value="Guinea-Bissau">Guinea-Bissau</option>
                  <option value="Guyana">Guyana</option>
                  <option value="Haiti">Haiti</option>
                  <option value="Honduras">Honduras</option>
                  <option value="Hungary">Hungary</option>
                  <option value="Iceland">Iceland</option>
                  <option value="India">India</option>
                  <option value="Indonesia">Indonesia</option>
                  <option value="Iran">Iran</option>
                  <option value="Iraq">Iraq</option>
                  <option value="Ireland">Ireland</option>
                  <option value="Israel">Israel</option>
                  <option value="Italy">Italy</option>
                  <option value="Jamaica">Jamaica</option>
                  <option value="Japan">Japan</option>
                  <option value="Jordan">Jordan</option>
                  <option value="Kazakhstan">Kazakhstan</option>
                  <option value="Kenya">Kenya</option>
                  <option value="Kiribati">Kiribati</option>
                  <option value="Korea, North">Korea, North</option>
                  <option value="Korea, South">Korea, South</option>
                  <option value="Kuwait">Kuwait</option>
                  <option value="Kyrgyzstan">Kyrgyzstan</option>
                  <option value="Laos">Laos</option>
                  <option value="Latvia">Latvia</option>
                  <option value="Lebanon">Lebanon</option>
                  <option value="Lesotho">Lesotho</option>
                  <option value="Liberia">Liberia</option>
                  <option value="Libya">Libya</option>
                  <option value="Liechtenstein">Liechtenstein</option>
                  <option value="Lithuania">Lithuania</option>
                  <option value="Luxembourg">Luxembourg</option>
                  <option value="Madagascar">Madagascar</option>
                  <option value="Malawi">Malawi</option>
                  <option value="Malaysia">Malaysia</option>
                  <option value="Maldives">Maldives</option>
                  <option value="Mali">Mali</option>
                  <option value="Malta">Malta</option>
                  <option value="Marshall Islands">Marshall Islands</option>
                  <option value="Mauritania">Mauritania</option>
                  <option value="Mauritius">Mauritius</option>
                  <option value="Mexico">Mexico</option>
                  <option value="Micronesia">Micronesia</option>
                  <option value="Moldova">Moldova</option>
                  <option value="Monaco">Monaco</option>
                  <option value="Mongolia">Mongolia</option>
                  <option value="Montenegro">Montenegro</option>
                  <option value="Morocco">Morocco</option>
                  <option value="Mozambique">Mozambique</option>
                  <option value="Myanmar (formerly Burma)">
                    Myanmar (formerly Burma)
                  </option>
                  <option value="Namibia">Namibia</option>
                  <option value="Nauru">Nauru</option>
                  <option value="Nepal">Nepal</option>
                  <option value="Netherlands">Netherlands</option>
                  <option value="New Zealand">New Zealand</option>
                  <option value="Nicaragua">Nicaragua</option>
                  <option value="Niger">Niger</option>
                  <option value="Nigeria">Nigeria</option>
                  <option value="North Macedonia (formerly Macedonia)">
                    North Macedonia (formerly Macedonia)
                  </option>
                  <option value="Norway">Norway</option>
                  <option value="Oman">Oman</option>
                  <option value="Pakistan">Pakistan</option>
                  <option value="Palau">Palau</option>
                  <option value="Panama">Panama</option>
                  <option value="Papua New Guinea">Papua New Guinea</option>
                  <option value="Paraguay">Paraguay</option>
                  <option value="Peru">Peru</option>
                  <option value="Philippines">Philippines</option>
                  <option value="Poland">Poland</option>
                  <option value="Portugal">Portugal</option>
                  <option value="Qatar">Qatar</option>
                  <option value="Romania">Romania</option>
                  <option value="Russia">Russia</option>
                  <option value="Rwanda">Rwanda</option>
                  <option value="Saint Kitts and Nevis">
                    Saint Kitts and Nevis
                  </option>
                  <option value="Saint Lucia">Saint Lucia</option>
                  <option value="Saint Vincent and the Grenadines">
                    Saint Vincent and the Grenadines
                  </option>
                  <option value="Samoa">Samoa</option>
                  <option value="San Marino">San Marino</option>
                  <option value="Sao Tome and Principe">
                    Sao Tome and Principe
                  </option>
                  <option value="Saudi Arabia">Saudi Arabia</option>
                  <option value="Senegal">Senegal</option>
                  <option value="Serbia">Serbia</option>
                  <option value="Seychelles">Seychelles</option>
                  <option value="Sierra Leone">Sierra Leone</option>
                  <option value="Singapore">Singapore</option>
                  <option value="Slovakia">Slovakia</option>
                  <option value="Slovenia">Slovenia</option>
                  <option value="Solomon Islands">Solomon Islands</option>
                  <option value="Somalia">Somalia</option>
                  <option value="South Africa">South Africa</option>
                  <option value="South Sudan">South Sudan</option>
                  <option value="Spain">Spain</option>
                  <option value="Sri Lanka">Sri Lanka</option>
                  <option value="Sudan">Sudan</option>
                  <option value="Suriname">Suriname</option>
                  <option value="Sweden">Sweden</option>
                  <option value="Switzerland">Switzerland</option>
                  <option value="Syria">Syria</option>
                  <option value="Taiwan">Taiwan</option>
                  <option value="Tajikistan">Tajikistan</option>
                  <option value="Tanzania">Tanzania</option>
                  <option value="Thailand">Thailand</option>
                  <option value="Timor-Leste">Timor-Leste</option>
                  <option value="Togo">Togo</option>
                  <option value="Tonga">Tonga</option>
                  <option value="Trinidad and Tobago">
                    Trinidad and Tobago
                  </option>
                  <option value="Tunisia">Tunisia</option>
                  <option value="Turkey">Turkey</option>
                  <option value="Turkmenistan">Turkmenistan</option>
                  <option value="Tuvalu">Tuvalu</option>
                  <option value="Uganda">Uganda</option>
                  <option value="Ukraine">Ukraine</option>
                  <option value="United Arab Emirates">
                    United Arab Emirates
                  </option>
                  <option value="United Kingdom">United Kingdom</option>
                  <option value="United States">United States</option>
                  <option value="Uruguay">Uruguay</option>
                  <option value="Uzbekistan">Uzbekistan</option>
                  <option value="Vanuatu">Vanuatu</option>
                  <option value="Vatican City">Vatican City</option>
                  <option value="Venezuela">Venezuela</option>
                  <option value="Vietnam">Vietnam</option>
                  <option value="Yemen">Yemen</option>
                  <option value="Zambia">Zambia</option>
                  <option value="Zimbabwe">Zimbabwe</option>
                </select>
              </div>

              <!-- <div>
                <label for="category" class="text-sm font-medium"
                  >Category</label
                >
                <select
                  v-model="category"
                  class="w-full p-3 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-yellow-400"
                >
                  <option value="">
                    Select the one that applies to you...
                  </option>
                  <option
                    v-for="(cat, index) in categoryData"
                    :key="index"
                    :value="cat.id"
                  >
                    {{ cat.name }}
                  </option>
                </select>
              </div> -->

              <!-- NIN -->
              <div class="space-y-1">
                <label class="text-sm font-medium"
                  >NIN <span class="text-red-500">*</span></label
                >
                <input
                  type="text"
                  v-model="nin"
                  placeholder="Enter 11-digit NIN"
                  maxlength="11"
                  @input="validateNIN"
                  class="w-full p-3 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2"
                  :class="{
                    'ring-red-500': ninError,
                    'ring-yellow': !ninError,
                  }"
                />
                <p v-if="ninError" class="text-red-500 text-xs mt-1">
                  NIN must be exactly 11 digits.
                </p>
              </div>

              <!-- Passport -->
              <div class="space-y-1">
                <label class="text-sm font-medium"
                  >Upload Passport <span class="text-red-500">*</span></label
                >
                <input
                  type="file"
                  accept="image/*"
                  @change="handlePassportUpload"
                  class="w-full p-3 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-yellow-400"
                />
              </div>

              <!-- Valid ID -->
              <div class="space-y-1">
                <label class="text-sm font-medium"
                  >Upload Valid ID <span class="text-red-500">*</span></label
                >
                <input
                  type="file"
                  accept=".jpg,.jpeg,.png,.pdf"
                  @change="handleIdCardUpload"
                  class="w-full p-3 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-yellow-400"
                />
              </div>

              <!-- Location -->
              <div class="space-y-1">
                <label class="text-sm font-medium">Address</label>
                <textarea
                  placeholder="Location: e.g. No 11, Ademola Street, Abuja"
                  v-model="address"
                  class="w-full p-3 border border-gray-300 rounded-lg text-sm resize-none focus:outline-none focus:ring-2 focus:ring-yellow-400"
                ></textarea>
              </div>
            </div>

            <!-- Staff Info Section -->
            <hr class="my-4 border-t border-gray-300" />
            <p class="text-sm font-medium text-black">
              Provide additional information of the staff that referred you
              <span class="text-yellow">*</span>
            </p>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
              <!-- Staff Name -->
              <div class="space-y-1">
                <label class="text-sm font-medium">Staff Name</label>
                <input
                  type="text"
                  placeholder="Enter staff name"
                  v-model="nameOfReferer"
                  class="w-full p-3 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-yellow-400"
                />
              </div>

              <!-- Staff Email -->
              <div class="space-y-1">
                <label class="text-sm font-medium">Staff Email</label>
                <input
                  type="email"
                  v-model="emailOfReferer"
                  placeholder="Enter staff email address"
                  @input="validateStaffEmail"
                  class="w-full p-3 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2"
                  :class="{
                    'ring-red-500': staffEmailError,
                    'ring-yellow-400': !staffEmailError && staffEmail,
                  }"
                />
                <p v-if="staffEmailError" class="text-red-500 text-xs mt-1">
                  Please enter a valid email address.
                </p>
              </div>
            </div>

            <!-- Submit Button -->
            <div class="pt-5 flex items-center justify-center">
              <button
                type="submit"
                class="w-1/2 bg-yellow text-white py-2 px-4 rounded-lg hover:bg-yellow-600 transition"
              >
                Apply Now
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import registrationService from "@/services/registrationService";
import { showErrorAlert, showLoaderAlert, showSuccessAlert } from "../services/reusableService";

export default {
  data() {
    return {
      categoryData: [],
      gender: "",
      country: "",
      // Required fields
      name: "",
      email: "",
      phone: "",
      nin: "",
      passport: null,
      idCard: null,

      // Optional fields
      // category: "",
      address: "",
      nameOfReferer: "",
      emailOfReferer: "",

      // Validation flags
      emailError: false,
      staffEmailError: false,
      phoneError: false,
      ninError: false,

      // Submission state
      isSubmitting: false,
    };
  },
  methods: {
    validateNIN() {
      const ninRegex = /^\d{11}$/;
      this.ninError = !ninRegex.test(this.nin);
    },
    validatePhone() {
      const phoneRegex = /^\d{11}$/;
      this.phoneError = !phoneRegex.test(this.phone);
    },
    validateEmail() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      this.emailError = !emailRegex.test(this.email);
    },
    validateStaffEmail() {
      const staffEmailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      this.staffEmailError =
        this.emailOfReferer && !staffEmailRegex.test(this.emailOfReferer);
    },
    handlePassportUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.passport = file; 
      }
    },

    handleIdCardUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.idCard = file;
      }
    },

    async submitForm(event) {
      showLoaderAlert('Processing your registration...')
      event.preventDefault();

      // Trigger validation checks
      this.validateEmail();
      this.validatePhone();
      this.validateNIN();
      this.validateStaffEmail();

      if (
        this.emailError ||
        this.phoneError ||
        this.ninError ||
        this.staffEmailError
      ) {
        showErrorAlert("Please fix the errors in the form before submitting.");
        return;
      }

      if (!this.passport || !this.idCard) {
        showErrorAlert("Please upload both Passport and Valid ID.");
        return;
      }

      const formData = new FormData();
      formData.append("name", this.name);
      formData.append("email", this.email);
      formData.append("phone", this.phone);
      formData.append("nin", this.nin);
      formData.append("passport", this.passport);
      formData.append("idCard", this.idCard);
      // formData.append("category", this.category);
      formData.append("address", this.address);
      formData.append("name_of_referer", this.nameOfReferer);
      formData.append("email_of_referer", this.emailOfReferer);

      try {
        this.isSubmitting = true;
        await registrationService.createRegistration(formData);
        showSuccessAlert("Registration submitted successfully!");
        this.resetForm();
      } catch (error) {
        console.error("Error submitting registration:", error);
        showErrorAlert("Something went wrong. Please try again.");
      } finally {
        this.isSubmitting = false;
      }
    },
    resetForm() {
      this.name = "";
      this.email = "";
      this.phone = "";
      this.nin = "";
      this.passport = "";
      this.idCard = "";
      // this.category = "";
      this.address = "";
      this.nameOfReferer = "";
      this.emailOfReferer = "";
      this.emailError = false;
      this.staffEmailError = false;
      this.phoneError = false;
      this.ninError = false;
    },
    async fetchCategory() {
      try {
        const response = await registrationService.getCategory();
        this.categoryData = response.data.data || [];
      } catch (error) {
        console.error("Failed to fetch category:", error);
      }
    },
  },
  mounted() {
    this.fetchCategory();
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("fade-in");
          } else {
            entry.target.classList.remove("fade-in");
          }
        });
      },
      {
        threshold: 0.2,
      }
    );

    document
      .querySelectorAll(".strategic-card")
      .forEach((card) => observer.observe(card));
  },
};
</script>

<style scoped>
svg path {
  fill: #ffffff !important;
  stroke: none !important;
  box-shadow: none !important;
}

svg {
  overflow: hidden !important;
}

.absolute.bottom-0 {
  line-height: 0 !important;
  padding-bottom: 0 !important;
  margin-bottom: -2px;
}

.overflow-hidden {
  overflow: hidden !important;
}

.who-style {
  font-family: Montserrat;
}

.strategic-card {
  opacity: 0;
  transform: translateY(50px);
  transition: opacity 1s ease-out, transform 1s ease-out;
  will-change: opacity, transform;
}

.strategic-card.fade-in {
  opacity: 1;
  transform: translateY(0);
}

.strategic-card:hover {
  transform: scale(1.03);
  /* box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2); */
  transition: transform 0.4s ease-out, box-shadow 0.4s ease-out;
  /* background-color: inherit !important; */
  box-shadow: none !important;
}
</style>
